export interface TableColumn {
  id?: string;
  [key: string]: any;
}

export type RowType = Record<string, unknown>;

export interface RowWithClientId {
  client_id?: number | null;
}

export interface BudgetRowType extends RowWithClientId {
  sah_budget_id?: string;
  origin_tag?: string;
}

export function filterBudgetRowFields<T extends BudgetRowType>(
  row: T,
  columns: TableColumn[],
  clientId: number | null,
  sahBudgetId?: string,
): T & { sah_budget_id: string | undefined; origin_tag: string; client_id: number | null } {
  const filtered = filterRowFields(row, columns, clientId);
  return {
    ...filtered,
    sah_budget_id: sahBudgetId ?? row.sah_budget_id,
    origin_tag: row.origin_tag || 'manual',
  };
}

export function filterRowFields<T extends RowWithClientId>(
  row: T,
  columns: TableColumn[],
  clientId: number | null,
): T & { client_id: number | null } {
  const allowedFields = columns.map((col) => col.id).filter((id): id is string => id !== undefined);

  const rowWithClientId = {
    ...row,
    client_id: row.client_id ?? clientId,
  };

  const filtered = Object.fromEntries(
    Object.entries(rowWithClientId).filter(
      ([key, value]) => allowedFields.includes(key) || (key === 'client_id' && value !== null),
    ),
  );

  return filtered as T & { client_id: number | null };
}
